import { Chip, type ChipProps } from '@mui/material';

/** Monospace code chip used for standard codes / display codes throughout the page. */
export function CodeChip({ code, sx, ...props }: { code: string } & Omit<ChipProps, 'label'>) {
  return (
    <Chip
      size="small"
      variant="outlined"
      label={code}
      sx={{
        fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
        fontWeight: 600,
        height: 20,
        borderRadius: 1,
        '& .MuiChip-label': { px: 0.75 },
        ...sx,
      }}
      {...props}
    />
  );
}

export default CodeChip;
